import React, { useContext } from "react";
import { OBJECT_TYPE } from "common/constants";
import { canDeleteDocumentUpload } from "common-client/utils/documentUploads";
import { useGetDocumentsForCustomMapGeometryQuery } from "../../generated/graphql";
import List from "../AddressPanel/DocumentUploads/List";
import ListItem from "../AddressPanel/DocumentUploads/ListItem";
import { AuthContext } from "../Authorization/AuthContext";
import { ContentWrapper } from "./__styles__/ObjectInformationPanel";
import { ObjectInfoPanelTabProps } from "./types";

const Files = ({ customMap, geometry }: ObjectInfoPanelTabProps) => {
  const { authorized } = useContext(AuthContext);
  const { data, loading, refetch } = useGetDocumentsForCustomMapGeometryQuery({
    variables: { geometryId: geometry.id, isGuest: false },
  });

  if (loading) {
    return (
      <ContentWrapper>
        <em>Loading...</em>
      </ContentWrapper>
    );
  }

  const documentUploads = data?.customMapGeometry?.documentUploads || [];

  return (
    <ContentWrapper>
      <List
        object={{
          id: geometry.id,
          objectType: OBJECT_TYPE.CUSTOM_MAP_GEOMETRY,
          objectLabel: geometry.label,
          customMapId: customMap.id,
        }}
      >
        {documentUploads.map(du => (
          <ListItem
            key={du.id}
            documentUpload={{
              ...du,
              isDeletable: canDeleteDocumentUpload({
                documentUpload: du,
                authorized,
              }),
            }}
            pathname={location.pathname}
            search={location.search}
            onUpdate={refetch}
          />
        ))}
      </List>
    </ContentWrapper>
  );
};

export default Files;
